const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Timing Matters in Trading</h1>
        <p>
          Stay in tune with what moves the markets. Plan your entries and exits
          using real-time economic data and global event releases with The Pips
          Economic Calendar.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
